module.exports = __webpack_public_path__ + "img/loadingError.0ff88382.png";